<template>
  <div class="container">
    <el-row>
      <el-col class="presonal-title" :span="24">
        <span>{{ $t('lang.external.personal.content.three.我的作品') }}</span>
        <span
          class="per-button"
          @click="handleOpen('https://jzwh.11dom.com/V5/edit/?type=2&mid=0')"
        >
          {{ $t('lang.external.personal.content.three.创建') }}
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="production">
      <el-col :span="6" v-for="model in models" :key="model.id">
        <div class="production-item">
          <img :src="model.cover" alt="" />
          <div class="production-item-info">
            <span>{{ model.title }}</span>
          </div>
          <div class="production-item-operate">
            <div class="operate" @click="handleView(model)">
              <i class="el-icon-view"></i>
              {{ $t('lang.external.personal.content.three.查看') }}
            </div>
            <div class="operate" @click="handleOpen(model.edit)">
              <i class="el-icon-edit"></i>
              {{ $t('lang.external.personal.content.three.编辑') }}
            </div>
            <div class="operate" @click="handleDelete(model.id)">
              <i class="el-icon-delete"></i>
              {{ $t('lang.external.personal.content.three.删除') }}
            </div>
          </div>
        </div>
      </el-col>
      <el-empty
        v-if="!models.length"
        :description="$t('lang.external.personal.content.three.暂无作品')"
      ></el-empty>
    </el-row>
    <el-row>
      <el-col :span="24">
        <PaginationChange
          :pageData="paging"
          @handleCurrentChange="changePaging"
        />
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('lang.external.personal.content.three.删除作品')"
      width="375px"
      top="0"
      custom-class="delete-dialog"
      :lock-scroll="false"
      :visible.sync="deleteDialog"
      :before-close="handleClose"
    >
      <span>{{
        $t(
          'lang.external.personal.content.three.删除作品将无法找回，请慎重操作！'
        )
      }}</span>
      <div class="dialog-btns">
        <span @click="confirmDelete" class="per-button btn-active">{{
          $t('lang.external.personal.content.three.删除')
        }}</span>
        <span @click="handleClose" class="per-button">{{
          $t('lang.external.personal.content.three.取消')
        }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  myProductions,
  destroy,
  viewProduction,
} from '@/api/personalCenter/index'
import PaginationChange from '@/components/common/paginationChange.vue'
export default {
  name: 'my-work',
  components: { PaginationChange },
  props: [],
  data() {
    return {
      deleteDialog: false,
      models: [],
      modelID: undefined,
      paging: {
        total: 0,
        currentPage: 1,
        pageSize: 40,
      },
      query: {
        text: '',
      },
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      myProductions({
        per_page: this.paging.pageSize,
        page: this.paging.currentPage,
        k: this.query.text,
      }).then((res) => {
        const { data, meta } = res.data.models
        this.models = data
        this.paging.total = parseFloat(meta.total)
        this.paging.currentPage = parseFloat(meta.current_page)
        this.paging.pageSize = parseFloat(meta.per_page)
      })
    },
    handleDelete(id) {
      this.modelID = id
      this.deleteDialog = true
    },
    handleClose() {
      this.deleteDialog = false
    },
    handleOpen(path) {
      let url = decodeURIComponent(path)
      window.location.href = url
    },
    async handleView(val) {
      await viewProduction(val.id)
        .then((res) => {
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      let url = decodeURIComponent(val.show)
      window.location.href = url
    },
    confirmDelete() {
      destroy(this.modelID).then((res) => {
        this.$notify({
          type: 'success',
          message: this.$t('lang.external.personal.content.three.删除成功！'),
          duration: 1500,
          title: 'SUCCESS',
        })
        this.modelID = undefined
        this.getData()
        this.handleClose()
      })
    },
    changePaging(val) {
      this.paging.currentPage = val
      this.getData()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .production {
    padding: 20px 15px;
    background: #fafbfc;
    margin-left: 0 !important;
    margin-right: 0 !important;
    &-item {
      background: #ffffff;
      box-shadow: 1px 1px 1px 0px rgba(194, 212, 224, 0.53);
      border-radius: 10px;
      margin: 10px 0;
      img {
        width: 100%;
        border-radius: 10px 10px 0px 0px;
      }
      &-info {
        font-size: 16px;
        padding: 10px;
      }
      &-operate {
        display: flex;
        align-items: center;
        border-top: 1px solid #d7d7d7;
        .operate {
          width: 100%;
          font-weight: 600;
          color: #666666;
          font-size: 12px;
          line-height: 3;
          text-align: center;
          cursor: pointer;
          &:nth-child(2) {
            border-left: 1px solid #d7d7d7;
            border-right: 1px solid #d7d7d7;
          }
        }
      }
    }
  }
  ::v-deep .delete-dialog {
    top: 50%;
    transform: translateY(-50%);
    .el-dialog__header {
      position: relative;
      padding: 0 20px;
      font-size: 16px;
      line-height: 2.8125;
      color: #666666;
      background: #edf2f6;
      border-radius: 5px 5px 0px 0px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
      }
    }
    .el-dialog__headerbtn {
      top: 50%;
      transform: translateY(-50%);
      .el-dialog__close {
        font-size: 14px;
        color: #999999;
      }
    }
    .el-dialog__body {
      text-align: center;
      .dialog-btns {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 40px;
        .per-button {
          &:first-child {
            margin-right: 28px;
          }
        }
      }
    }
  }
}
</style>